import clsx from 'clsx';
import styles from './Skeleton.module.css';

export type SkeletonShape = 'text' | 'title' | 'block' | 'circle' | 'control';

export interface SkeletonProps {
  readonly shape?: SkeletonShape | undefined;
  /** Width as a share of the container, for text lines of varied length. */
  readonly width?: `${number}%` | undefined;
  readonly className?: string | undefined;
}

/** Placeholder in the shape of the content that is loading. Purely visual. */
export const Skeleton = ({ shape = 'text', width, className }: SkeletonProps) => (
  <span
    className={clsx(styles.skeleton, styles[shape], className)}
    style={width ? { width } : undefined}
    aria-hidden="true"
  />
);
